import { Component, inject, input, OnInit, signal } from '@angular/core';
import { EditCountryModel, ICountryModel, LocationsClient } from 'src/api/services/generated/api-clients';
import {
  DokaModal,
  DokaModalController,
  DokaSelect,
  DokaSelectOption,
  DokaButton,
  DokaTextField,
} from '@doka/angular-core';
import { I18NextEagerPipe } from 'angular-i18next';
import { FormsModule } from '@angular/forms';
import { firstValueFrom } from 'rxjs';

@Component({
  templateUrl: './edit-country-slide-over.component.html',
  imports: [DokaModal, I18NextEagerPipe, DokaSelect, DokaSelectOption, DokaButton, DokaTextField, FormsModule],
})
export class EditCountrySlideOverComponent implements OnInit {
  private readonly modalCtrl = inject(DokaModalController);
  private readonly locationsClient = inject(LocationsClient);

  public readonly country = input.required<ICountryModel>();
  protected isLoading = signal(false);
  protected submitted = signal(false);
  protected selectedMainIsoCurrencyCode = signal('');

  public ngOnInit() {
    this.selectedMainIsoCurrencyCode.set(this.country().mainIsoCurrencyCode);
  }

  protected closeModal(result?: boolean, role?: string) {
    this.modalCtrl.dismiss(result, role);
  }

  protected async submit() {
    this.submitted.set(true);

    if (!this.selectedMainIsoCurrencyCode()) {
      return;
    }

    try {
      this.isLoading.set(true);
      await firstValueFrom(
        this.locationsClient.editCountry(
          this.country().id,
          new EditCountryModel({ mainIsoCurrencyCode: this.selectedMainIsoCurrencyCode() }),
        ),
      );

      this.closeModal(true, 'saved');
    } catch (error) {
      console.error('Error updating country:', error);
    } finally {
      this.isLoading.set(false);
    }
  }
}
